import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  TransportManagementReportInitialState,
  TransportManagementReportLoad,
} from './transport-management-report.actions';
import { ProfileReportItem, TransportManagementProfileReport } from '../../../../models';
import { TransportManagementReportState } from './transport-management-report.state';

@Injectable({ providedIn: 'root' })
export class TransportManagementReportFacade implements LoadDataFacade, SetInitialStateFacade {
  report$: Observable<TransportManagementProfileReport> = this.store.select(TransportManagementReportState.getReport);
  loaded$: Observable<boolean> = this.store.select(TransportManagementReportState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new TransportManagementReportLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementReportInitialState());
  }

  setReportRequiredFields(report: TransportManagementProfileReport): TransportManagementProfileReport {
    const result = {} as TransportManagementProfileReport;
    Object.keys(report).forEach((reportKey: string) => {
      result[reportKey] = Array.isArray(report[reportKey])
        ? report[reportKey].filter((item: ProfileReportItem) => item.required)
        : report[reportKey];
    });
    return result;
  }
}
